import { render } from "./BrandConnectionBlog.vue?vue&type=template&id=366bb103&scoped=true"
import script from "./BrandConnectionBlog.vue?vue&type=script&lang=js"
export * from "./BrandConnectionBlog.vue?vue&type=script&lang=js"

import "./BrandConnectionBlog.vue?vue&type=style&index=0&id=366bb103&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366bb103"]])

export default __exports__